/** Подпись филиала на доске ОО («20b» → «20Б»). 16.10: вынесено из AdminStrip.tsx без изменений — нужна и «+» игры
 *  (куда оператор уже поставлен, oo/dayBusy.ts), а тянуть ради неё компонент с CSS в чистую функцию нельзя (тесты). */
const RU_BRANCH: Record<string, string> = { "20b": "20Б", psih: "Псих", svo: "СВО", among: "Амонг" };
export const ruBranch = (br: string) => RU_BRANCH[br.toLowerCase()] ?? br.toUpperCase();
